<template>
  <NetworkStatus v-if="isOffline" />
  <div v-else>  
<div class="card text-center w-60 mx-auto">
    <!-- Section Photo de profil avec le nouveau composant -->
    <div class="text-center mt-4">
        <ZoomableAvatar :photoUrl="user.photo" class="ZoomableAvatar mx-auto" />
        <h5 class="mt-3">{{ user.firstname }} {{ user.lastname }}</h5>
        <p class="text-muted">{{ user.username }}</p>

        <!-- Bouton de transfert de propriété (visible seulement pour les admins) -->
        <div v-if="user.is_staff" class="mt-3">
          <button class="btn btn-outline-success d-inline-flex align-items-center" data-bs-toggle="modal" data-bs-target="#transferOwnershipModal" @click.prevent="openTransferModal" :title="$t('transfer_ownership.transfer_ownership')">
            <i class="fa fa-exchange-alt me-2" style="font-size: 16px"></i>
            <span>{{ $t("transfer_ownership.transfer_ownership") }}</span>
          </button>
        </div>
    </div>

    <!-- Section Informations -->
    <div class="info-section w-80 mx-auto mt-4 mb-6">
        <div class="info-grid">
            <div class="info-item">
                <label>{{ $t("profil.username") }}</label>
                <p class="info-value mx-1">{{ user.username }}</p>
                <hr class="mt-2 horizontal" />
            </div>

            <div class="info-item">
                <label>{{ $t("profil.email") }}</label>
                <p class="info-value mx-1">{{ user.email }}</p>
                <hr class="mt-2 horizontal" />
            </div>

            <div class="info-item">
                <label>{{ $t("profil.first_name") }}</label>
                <p v-if="user.firstname" class="info-value mx-1">{{ user.firstname }}</p>
                <p v-else class="info-value mx-1">---------</p>
                <hr class="mt-2 horizontal" />
            </div>

            <div class="info-item">
                <label>{{ $t("profil.last_name") }}</label>
                <p v-if="user.lastname" class="info-value mx-1">{{ user.lastname }}</p>
                <p v-else class="info-value mx-1">----------</p>
                <hr class="mt-2 horizontal" />
            </div>

            <div class="info-item">
                <label>{{ $t("profil.phone") }}</label>
                <p class="info-value mx-1">{{ user.phone }}</p>
                <hr class="mt-2 horizontal" />
            </div>
        </div>
    </div>
</div>

<!-- Modal transférer propriété -->
<div class="modal fade" id="transferOwnershipModal" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1" aria-labelledby="transferOwnershipLabel" aria-hidden="true">
  <div class="modal-dialog">
    <div class="card">
      <div class="modal-content">
          <div class="modal-header border-0 d-flex flex-column justify-content-center align-items-center">
          <img src="@/assets/img/transfert-ownership.png" alt="Transfer Ownership" class="transfer-icon mb-2" style="display: block; margin: 0 auto;" />
          
          <h5 class="modal-title mb-0 text-center w-100" id="transferOwnershipLabel" style="margin-top: 10px;">{{ $t("transfer_ownership.transfer_account_ownership") }}</h5>
          <button type="button" class="btn-close position-absolute end-0 me-3" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body pt-2 pb-2">
          <!-- Step 1: Vérification admin - Envoi du code -->
          <div v-if="transferStep === 1">
            <div class="mb-3">
              <label for="adminPhone" class="form-label">{{ $t("transfer_ownership.current_admin_phone") }}</label>
              <argon-input v-model="adminPhone" id="adminPhone" type="text" required :disabled="true" />
            </div>
            <div class="modal-footer border-0 pb-2">
              <argon-button type="button" class="btn bg-transparent" data-bs-dismiss="modal" style="width: 150px; height: 50px; padding-top: 15px; border: 1px solid rgba(255, 255, 255, 0.4);">
                {{ $t("button.cancel") }}
              </argon-button>
              <argon-button :loading="stepLoading" color="success" variant="gradient" type="button" style="width: 150px; height: 50px; padding-top: 15px" @click.prevent="sendVerificationCode" :disabled="stepLoading || !adminPhone">
                <span v-if="!stepLoading">{{ $t("transfer_ownership.send_code") }}</span>
                <span v-else>
                  <Spinner />
                </span>
              </argon-button>
            </div>
          </div>

          <!-- Step 2: Vérification code -->
          <div v-if="transferStep === 2">
            <div class="mb-3">
              <label for="enteredCode" class="form-label">{{ $t("transfer_ownership.verification_code_eska") }}</label>
              <argon-input v-model="enteredCode" type="text" id="enteredCode" required :placeholder="$t('transfer_ownership.enter_6_digit_code')" />
            </div>
            <div class="modal-footer border-0 pb-2">
              <argon-button type="button" class="btn bg-transparent" @click.prevent="transferStep = 1" style="width: 150px; height: 50px; padding-top: 15px; border: 1px solid rgba(255, 255, 255, 0.4);">{{ $t("button.previous") }}</argon-button>
              <argon-button :loading="stepLoading" color="success" variant="gradient" type="button" style="width: 150px; height: 50px; padding-top: 15px" @click.prevent="verifyCode" :disabled="stepLoading || !enteredCode">
                <span v-if="!stepLoading">{{ $t("transfer_ownership.verify") }}</span>
                <span v-else>
                  <Spinner />
                </span>
              </argon-button>
            </div>
          </div>

          <!-- Step 3: Saisie du numéro du nouveau propriétaire -->
          <div v-if="transferStep === 3">
            <div class="mb-3">
              <label for="newPhone" class="form-label">{{ $t("transfer_ownership.new_owner_phone") }}</label>
              <argon-phone-input v-model="transferForm.newPhone" id="newPhone" :country-code="'237'" required />
            </div>
            <div class="modal-footer border-0 pb-2">
              <argon-button type="button" class="btn bg-transparent" @click.prevent="transferStep = 2" style="width: 150px; height: 50px; padding-top: 15px; border: 1px solid rgba(255, 255, 255, 0.4);">{{ $t("button.previous") }}</argon-button>
              <argon-button :loading="stepLoading" color="success" variant="gradient" type="button" style="width: 150px; height: 50px; padding-top: 15px" @click.prevent="checkNewUser" :disabled="stepLoading || !transferForm.newPhone">
                <span v-if="!stepLoading">{{ $t("transfer_ownership.verify") }}</span>
                <span v-else>
                  <Spinner />
                </span>
              </argon-button>
            </div>
          </div>

          <!-- Step 4: Confirmation des informations récupérées -->
          <div v-if="transferStep === 4">
            <div class="d-flex align-items-center justify-content-center p-3 rounded">
              <argon-avatar v-if="eskaData.photo" :img="eskaData.photo" alt="Photo" size="xxl" circular shadow="sm" class="me-3"></argon-avatar>
              <div v-if="!eskaData.photo" class="me-3">
                <div class="bg-primary text-white rounded-circle d-flex align-items-center justify-content-center" style="width: 80px; height: 80px; font-size: 24px; font-weight: bold;">
                  {{ eskaData.first_name ? eskaData.first_name.charAt(0) : '' }}{{ eskaData.last_name ? eskaData.last_name.charAt(0) : '' }}
                </div>
              </div>
              <div>
                <h5 class="mb-1">{{ eskaData.first_name }} {{ eskaData.last_name }}</h5>
                <p class="text-muted mb-0"><i class="fas fa-phone me-2"></i>{{ eskaData.phone }}</p>
              </div>
            </div>
            <div class="modal-footer border-0 pb-2">
              <argon-button type="button" class="btn bg-transparent" @click.prevent="transferStep = 3" style="width: 150px; height: 50px; padding-top: 15px; border: 1px solid rgba(255, 255, 255, 0.4);">{{ $t("button.previous") }}</argon-button>
              <argon-button :loading="stepLoading" color="success" variant="gradient" type="button" style="width: 150px; height: 50px; padding-top: 15px" @click.prevent="confirmTransfer" :disabled="stepLoading">
                <span v-if="!stepLoading">{{ $t("transfer_ownership.confirm_transfer") }}</span>
                <span v-else>
                  <Spinner />
                </span>
              </argon-button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

</div>
</template>

<style scoped>
/* ...existing code... */
</style>

<script>
import { getinfoMembers, transferOwnerInfo } from "@/utils/services";
import NetworkStatus from "@/views/components/NetworkStatus.vue";
import ZoomableAvatar from "@/views/components/ZoomableAvatar.vue";
import ArgonButton from '@/components/ArgonButton';
import ArgonInput from '@/components/ArgonInput';
import ArgonPhoneInput from '@/components/ArgonPhoneInput';
import ArgonAvatar from '@/components/ArgonAvatar';
import Spinner from '@/views/components/Spinner.vue';
import { toast } from 'vue3-toastify';
import 'vue3-toastify/dist/index.css';

export default {
name: "Info-personnelle",
data() {
    return {
        user: {
            username: '',
            lastname: '',
            firstname: '',
            email: '',
            phone: '',
            photo: '',
            is_staff: false
        },
        isOffline: false,  
        apiError: false,
        // Transfer flow
        transferForm: { newPhone: '' },
        transferStep: 1,
        stepLoading: false,
        adminPhone: '',
        enteredCode: '',
        eskaData: { photo: '', first_name: '', last_name: '', phone: '', email: '' },
    };
},
components: {
    NetworkStatus,
    ZoomableAvatar,
    ArgonButton,
    ArgonInput,
    ArgonPhoneInput,
    ArgonAvatar,
    Spinner
}, 

async created() {
    await this.loadUserData();
},

async mounted() {
  // Initialiser l'état de connexion au montage
  await this.updateOnlineStatus();
  await this.loadUserData();

  // Ajouter les event listeners pour les changements de réseau
  window.addEventListener("online", this.updateOnlineStatus);
  window.addEventListener("offline", this.updateOnlineStatus);
  this.intervalId = setInterval(this.checkInternetConnection, 1000);
  

  // Charger les données initiales
  if (!this.isOffline) {
    
    await this.loadUserData();
  }
},

beforeUnmount() {
  window.removeEventListener('online', this.updateOnlineStatus);
  window.removeEventListener('offline', this.updateOnlineStatus);

  if (this.intervalId) {
    clearInterval(this.intervalId);
  }
},

methods: {
  async updateOnlineStatus() {
  // Vérifier si le navigateur est en ligne
  if (navigator.onLine) {
    try {
      // Vérifier si les API sont accessibles
      await this.checkConnection();
      this.isOffline = false; // Tout fonctionne, on est en ligne
    } catch (error) {
      console.error("Error checking connection:", error);
      this.isOffline = true; // Les API ne répondent pas, on est hors ligne
    }
  } else {
    // Pas de connexion internet détectée
    this.isOffline = true;
  }
},

async checkConnection(username) {
  try {
    // Essayer les deux appels API
    await Promise.all([
    getinfoMembers(username)
       
    ]);
    this.apiError = false; // Les API répondent correctement
  } catch (error) {
    console.error("API Error:", error);
    this.apiError = true; // Les API ne répondent pas
  }
},

    async loadUserData() {
        try {
            const username = localStorage.getItem('username');
            if (username) {
                const userData = await getinfoMembers(username);
                if (userData) {
                    this.user = {
                        username:userData.username,
                        lastname:userData.last_name,
                        firstname:userData.first_name,
                        email:userData.email,
                        phone:userData.phone,
                        photo:userData.photo,
                        is_staff: userData.is_staff || false
                    };
                    
                } else {
                    console.error("Aucune donnée utilisateur reçue");
                }
            } else {
                console.error("Aucun nom d'utilisateur trouvé dans le localStorage");
            }
        } catch (error) {
            console.error("Erreur lors du chargement des informations de l'utilisateur:", error);
        }
    },

    // Ouvrir modal et préparer le transfert
    openTransferModal() {
      this.transferForm = { newPhone: '' };
      this.transferStep = 1;
      this.enteredCode = '';
      this.eskaData = { photo: '', first_name: '', last_name: '', phone: '', email: '' };
      this.adminPhone = this.user.phone || '';
    },

    // Étape 1: Envoyer le code de vérification
    async sendVerificationCode() {
      if (this.stepLoading) return;

      try {
        this.stepLoading = true;

        const result = await transferOwnerInfo('check', this.adminPhone);
        if (result.status === 200) {
          toast.success(result.data.message, { autoClose: 3000 });
          this.transferStep = 2;
        }
        if (result.status === 400) {
          toast.error(result.data.error, { autoClose: 3000 });
        }
      } catch (error) {
        toast.error('Une erreur est survenue lors de l\'envoi du code.', { autoClose: 3000 });
      } finally {
        this.stepLoading = false;
      }
    },

    // Étape 2: Vérifier le code
    async verifyCode() {
      if (this.stepLoading) return;
      try {
        this.stepLoading = true;

        const trimmedCode = this.enteredCode.trim();

        const result = await transferOwnerInfo('confirm', this.adminPhone, trimmedCode);

        if (result.status === 200) {
          toast.success(result.data.message, { autoClose: 3000 });
          this.transferStep = 3;
        } 
        if (result.status === 400) {
          toast.error(result.data.error, { autoClose: 3000 });
        }
      } catch (error) {
        console.error('Erreur lors de la vérification du code:', error);
        toast.error('Une erreur est survenue lors de la vérification du code.', { autoClose: 3000 });
      } finally {
        this.stepLoading = false;
      }
    },

    // Étape 3: Vérifier le nouveau utilisateur
    async checkNewUser() {
      if (this.stepLoading) return;

      try {
        this.stepLoading = true;

        // Formater le numéro avec le code pays si nécessaire
        let formattedPhone = this.transferForm.newPhone;
        if (!formattedPhone.startsWith('237')) {
          formattedPhone = '237' + formattedPhone;
        }

        const result = await transferOwnerInfo('check_new_user', this.adminPhone, '', formattedPhone);
        if (result.status === 200) {
          this.eskaData = {
            first_name: result.data.resp.first_name,
            last_name: result.data.resp.last_name,
            phone: result.data.resp.phone,
            photo: result.data.resp.photo
          };
          this.transferStep = 4;
        }
        if (result.status === 404 || result.status === 403) {
          toast.error(result.data.error, { autoClose: 3000 });
        }
      } catch (error) {
        if (error.response && error.response.data && error.response.data.message) {
          toast.error(error.response.data.error, { autoClose: 3000 });
        } else {
          toast.error('Une erreur est survenue lors de la vérification du numéro.', { autoClose: 3000 });
        }
      } finally {
        this.stepLoading = false;
      }
    },

    // Étape 4: Confirmer le transfert
    async confirmTransfer() {
      if (this.stepLoading) return;

      try {
        this.stepLoading = true;

        // Formater le numéro avec le code pays si nécessaire
        let formattedPhone = this.transferForm.newPhone;
        if (!formattedPhone.startsWith('237')) {
          formattedPhone = '237' + formattedPhone;
        }

        const result = await transferOwnerInfo('transfer', this.adminPhone, '', formattedPhone);

        if (result.status === 201) {
          toast.success(result.data.message, { autoClose: 3000 });

          setTimeout(() => {
            localStorage.clear();
            window.location.href = '/signin';
          }, 2000);
        } 
        if (result.status === 400) {
          toast.error(result.data.error, { autoClose: 3000 });
        }
      } catch (error) {
        console.error('Erreur lors du transfert:', error);
        toast.error('Une erreur est survenue lors du transfert de propriété.', { autoClose: 3000 });
      } finally {
        this.stepLoading = false;
      }
    }
}
};
</script>

<style scoped>

.info-section {
text-align: left;
padding: 20px;
}
.horizontal {
background-image: linear-gradient(to right,
    rgba(255, 255, 255, 0),
    white,
    rgba(255, 255, 255, 0)) !important;
transform: translateX(-40px);
}

.info-grid {
display: grid;
grid-template-columns: repeat(2, 1fr);
gap: 20px;
}

.info-item {
padding: 10px;
border-radius: 8px;
}

.info-item label {
display: block;
color: rgba(250, 250, 250, 0.6);
font-size: 0.9rem;
margin-bottom: 5px;
}

.info-value {
margin: 0;
font-size: 1rem;
color: white;
padding: 5px 0;
}

.card {
background: rgba(0, 0, 0, 0.2);
}

.transfer-icon {
  width: 110px;
  height: 110px;
}

.modal-body {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  padding-left: 2.5rem;
  padding-right: 2.5rem;
}
/*=======css table ====*/

.card .table thead tr th {
  width: 30%;
}



.card .table tbody tr:hover td .amount {
  filter: blur(2px);

}

.card .table tbody tr {
  transition: 0.7s;
  cursor: pointer;
}

.card .table tbody tr {
  position: relative;
}

.card .table tbody tr td .content-td {
  position: absolute;
  top: 25px;


}

.action {
  display: none;
}

.card .table tbody tr:hover .action {
  display: block;
}



.pagination button:disabled {
  cursor: not-allowed;
  opacity: 0.6;
}

/*=======css table ====*/

/* Modal and input width adjustments */
#transferOwnershipModal .modal-dialog {
  max-width: 650px;
  margin-left: auto;
  margin-right: auto;
}

/* Centrage horizontal pour toutes les modals Bootstrap, ajusté pour la sidebar */
@media (min-width: 992px) {
  .modal-dialog {
    margin-left: calc(750px + auto);
    /* 250px = largeur sidebar, ajustez si besoin */
    margin-right: auto;
  }
}

.btn-close {

  top: 10px;
  position: absolute;
}

.transfer-icon {
  width: 110px;
  height: 110px;
}

.modal-body {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  padding-left: 2.5rem;
  padding-right: 2.5rem;
}
</style>
